import script from "./OrderStatusBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderStatusBadge.vue?vue&type=script&setup=true&lang=ts"

import "./OrderStatusBadge.vue?vue&type=style&index=0&id=7079d0ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7079d0ce"]])

export default __exports__